/**
 * Tenant-admin setup API client (Phase 44.3).
 *
 * Wraps the eight /api/tenant/setup/* + /api/tenant/activate endpoints
 * shipped in Phase 44.1. The store consumes these; nothing else should
 * import this module directly.
 */

import { request } from "./api.js";

export const getSetup = () => request("/api/tenant/setup");

export const putProfile = (patch) =>
  request("/api/tenant/setup/profile", {
    method: "PUT",
    body: JSON.stringify(patch),
  });

export const putCatalogue = (patch) =>
  request("/api/tenant/setup/catalogue", {
    method: "PUT",
    body: JSON.stringify(patch),
  });

export const regenerateProfile = () =>
  request("/api/tenant/setup/regenerate-profile", { method: "POST" });

export const regenerateCatalogue = () =>
  request("/api/tenant/setup/regenerate-catalogue", { method: "POST" });

export const getRegenerateStatus = (jobId) =>
  request(
    `/api/tenant/setup/regenerate-status/${encodeURIComponent(jobId)}`
  );

export const activate = () =>
  request("/api/tenant/activate", { method: "POST" });

export const reopen = () =>
  request("/api/tenant/setup/reopen", { method: "POST" });
